import { useSettingsStore } from '@features/settings/stores/useSettingsStore'

/**
 * Whether area menus stay open beside the page (the Menus preference's Always
 * open, which a menu's pin button sets), so the current area's menu is there.
 */
export function useIsSidebarPinned(): boolean {
  return useSettingsStore((s) => s.sidebarMenuMode === 'pinned')
}
